import { CompanyConfig } from "#root/config/interfaces/company-config.interface";

export const COMPANY_CONFIG_IP: CompanyConfig = {
  name: "Inmobiliaria Platino S.A. de C.V.",
  socialMediaName: "platinoinmobiliaria",
  email: "inmobiliaria@platino.hn",
  rtn: "05019018010267",
  watermark: "assets/images/companies/inmobiliaria-platino/app_isotype.png",
  blackLettersLogo:
    "assets/images/companies/inmobiliaria-platino/black_letters_logo.png",
  oneLineBlackLettersLogo:
    "assets/images/companies/inmobiliaria-platino/one_line_black_letters_logo.png",
  quoteGroupLogo:
    "assets/images/companies/inmobiliaria-platino/black_letters_logo.png",
  quoteLogo:
    "assets/images/companies/inmobiliaria-platino/black_letters_logo.png",
  virtualSign: "assets/images/companies/inmobiliaria-platino/virtual_sign.png",
  quoteParkingClause: "Incluye estacionamiento para {{VEHICULOS}}.",
  quoteParkingInRooms: false,
  quoteRooms: ["sala", "comedor", "cocina"],
};
